import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import WhyDrVillarreal from "../pages/why-dr-villarreal/page";
import Blog from "../pages/blog/page";
import AchcAccreditationGuide from "../pages/blog/achc-accreditation-guide";
import HomeHealthComplianceTips from "../pages/blog/home-health-compliance-tips";
import MockSurveyPreparation from "../pages/blog/mock-survey-preparation";
import AchcVsJointCommission from "../pages/blog/achc-vs-joint-commission";
import CmsConditionsOfParticipation from "../pages/blog/home-health-cms-conditions-of-participation";
import QapiProgramHomeHealth from "../pages/blog/qapi-program-home-health";
import PolicyProcedureDevelopmentBlog from "../pages/blog/home-health-policy-procedure-development";
import StaffTrainingAchc from "../pages/blog/home-health-staff-training-achc";
import StartingHomeHealthAgency from "../pages/blog/starting-home-health-agency";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";
import AchcAccreditationPreparation from "../pages/services/achc-accreditation-preparation";
import MockSurveyService from "../pages/services/mock-survey";
import PolicyProcedureDevelopmentService from "../pages/services/policy-procedure-development";
import ComplianceAuditService from "../pages/services/compliance-audit";
import StaffTrainingService from "../pages/services/staff-training";
import OngoingComplianceSupportService from "../pages/services/ongoing-compliance-support";
import AccreditationChecklist from "../pages/resources/accreditation-checklist";
import AchcGlossary from "../pages/resources/achc-glossary";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/achc-accreditation-preparation", element: <AchcAccreditationPreparation /> },
  { path: "/services/mock-survey", element: <MockSurveyService /> },
  { path: "/services/policy-procedure-development", element: <PolicyProcedureDevelopmentService /> },
  { path: "/services/compliance-audit", element: <ComplianceAuditService /> },
  { path: "/services/staff-training", element: <StaffTrainingService /> },
  { path: "/services/ongoing-compliance-support", element: <OngoingComplianceSupportService /> },
  { path: "/why-dr-villarreal", element: <WhyDrVillarreal /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/achc-accreditation-guide", element: <AchcAccreditationGuide /> },
  { path: "/blog/home-health-compliance-tips", element: <HomeHealthComplianceTips /> },
  { path: "/blog/mock-survey-preparation", element: <MockSurveyPreparation /> },
  { path: "/blog/achc-vs-joint-commission", element: <AchcVsJointCommission /> },
  { path: "/blog/home-health-cms-conditions-of-participation", element: <CmsConditionsOfParticipation /> },
  { path: "/blog/qapi-program-home-health", element: <QapiProgramHomeHealth /> },
  { path: "/blog/home-health-policy-procedure-development", element: <PolicyProcedureDevelopmentBlog /> },
  { path: "/blog/home-health-staff-training-achc", element: <StaffTrainingAchc /> },
  { path: "/blog/starting-home-health-agency", element: <StartingHomeHealthAgency /> },
  { path: "/faq", element: <Faq /> },
  { path: "/contact", element: <Contact /> },
  { path: "/resources/accreditation-checklist", element: <AccreditationChecklist /> },
  { path: "/resources/achc-glossary", element: <AchcGlossary /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
